module.exports = __webpack_public_path__ + "img/bnextlogo.2712f9e1.svg";